import initApplicationGlobal from '../Global/Global';

export default function initContactsPage(eventHub) {
  initApplicationGlobal(eventHub);
}
